import React, { useMemo } from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { assetUrl } from '~/helpers';
import ActionButton from './ActionButton';
import { useTranslation } from 'react-i18next';
import {
  RichText,
  RichTextEditor,
} from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { useMedia } from 'react-use-media';

export interface TextAreaProps {
  onBackClick: () => void;
  className?: string;
  hideBackButton?: boolean;
  showBonjoroBadge?: boolean;
  value?: RichText;
  onChange?: (value: RichText) => void;
}

export default function TextArea({
  className = '',
  onBackClick,
  hideBackButton = false,
  onChange,
  value,
  showBonjoroBadge = false,
}: TextAreaProps) {
  const { t } = useTranslation();

  const isMobile = useMedia({
    maxHeight: 768,
  });

  const richTextEditorProps = useMemo(() => {
    const props = {
      onChange,
      value,
      className:
        'v2-min-h-full v2-h-full md:!v2-h-[250px] border-none px-0 text-lg',
      editorClassName: 'px-5',
      placeholder: t('testimonial:typeAnswer.placeholder'),
      toolbarClassName: 'v2-rounded-bl-none',
    };

    /**
     * There is a default scroll behavior from the Slate Editable component which
     * conflicts with the Typeform's behavior in mobile. Removing the component's
     * scroll behavior when mobile reso is detected fixes the problem.
     */
    if (isMobile) {
      props['onScrollToView'] = () => undefined;
    }
    return props;
  }, [value, isMobile]);

  return (
    <div className={className}>
      <div className='flex justify-between px-5'>
        {!hideBackButton && (
          <ActionButton
            icon={faArrowLeft}
            label={t('testimonial:videoPlayer.back')}
            onClick={onBackClick}
          />
        )}
        {showBonjoroBadge && (
          <a href='/' target='_blank' rel='noopener noreferrer'>
            <img
              className=' md:hidden w-28'
              src={assetUrl('assets/images/icons/poweredby-bonjoro-dark.svg')}
            />
          </a>
        )}
      </div>
      <div className='h-full mt-2 scrollbar-thin scrollbar-track-neutral-200 scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full'>
        <RichTextEditor {...richTextEditorProps} />
      </div>
    </div>
  );
}
